import React, { useEffect, useState } from 'react';
import api from '../../api';

function AdminMessages() {
  const [messages, setMessages] = useState([]);

  const load = () => api.get('/contact').then(r => setMessages(r.data)).catch(() => {});

  useEffect(() => { load(); }, []);

  const markRead = async (id) => {
    await api.put(`/contact/${id}/read`);
    load();
  };

  const deleteMsg = async (id) => {
    if (!window.confirm('¿Eliminar este mensaje?')) return;
    await api.delete(`/contact/${id}`);
    load();
  };

  const unread = messages.filter(m => !m.read).length;

  return (
    <>
      <div className="admin-topbar">
        <h1>Mensajes de Contacto</h1>
        {unread > 0 && <span style={{ background: 'var(--accent)', color: 'white', padding: '4px 12px', borderRadius: '20px', fontSize: '0.85rem' }}>{unread} sin leer</span>}
      </div>
      <div className="admin-content">
        <div className="admin-card">
          {messages.length === 0 ? (
            <p style={{ color: 'var(--text-light)', padding: '2rem', textAlign: 'center' }}>No hay mensajes aún.</p>
          ) : (
            messages.map(msg => (
              <div key={msg.id} className={`message-item ${!msg.read ? 'unread' : ''}`}>
                <div className="msg-content">
                  <div className="msg-header">
                    <h4>{msg.name} {msg.subject && `— ${msg.subject}`}</h4>
                    <span>{new Date(msg.created_at).toLocaleString('es-CO')}</span>
                  </div>
                  <div className="msg-meta">{msg.email} {msg.phone && `| ${msg.phone}`}</div>
                  <div className="msg-body">{msg.message}</div>
                </div>
                <div className="msg-actions">
                  {!msg.read && (
                    <button className="btn-save" style={{ padding: '6px 12px', fontSize: '0.8rem' }} onClick={() => markRead(msg.id)}>
                      Leído
                    </button>
                  )}
                  <button className="btn-danger" style={{ padding: '6px 12px', fontSize: '0.8rem' }} onClick={() => deleteMsg(msg.id)}>
                    Eliminar
                  </button>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </>
  );
}

export default AdminMessages;
